import { render, staticRenderFns } from "./ClientsTable.vue?vue&type=template&id=2ee5d669&scoped=true&"
import script from "./ClientsTable.vue?vue&type=script&lang=js&"
export * from "./ClientsTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientsTable.vue?vue&type=style&index=0&id=2ee5d669&lang=scss&scoped=true&"
import style1 from "./ClientsTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee5d669",
  null
  
)

export default component.exports